'use strict'

import React from 'react';

import Layout from './Layout.jsx';

import ProjectMenu from './components/ProjectMenu.jsx';
import Flag from './components/Flag.jsx';

import {setupSchedule,addTotalsToSchedule} from './plan/Plan.jsx';

import Translations from '../app/utils/translations.js';
let translations=new Translations([
  require('./plan/labels/english.js'),
  require('./plan/labels/norwegian.js')
]);

class Stage extends React.Component {
  asNumber(value) {
    var floatNumber=parseFloat(value);
    return isNaN(floatNumber) ? value : floatNumber.toLocaleString();
  }

  editStage(event) {
    event.preventDefault();
    if (this.props.onEdit!==undefined) {
      this.props.onEdit(this.props.id);
    }
  }

  render() {
    var baseStyle=this.props.id==="_totalStage"
      ? {backgroundColor: "#EEEEEE", borderTop:"double black 4px", borderBottom:" solid black 1px", paddingTop: 5, paddingBottom: 5, fontWeight: "bold"}
      : this.props.type==="total"
        ? {backgroundColor: "#EEEEEE", borderTop:"solid grey 2px", borderBottom:" solid grey 1px", paddingTop: 5, paddingBottom: 5, fontWeight: "bold"}
        : {};
    var timeStyle=Object.assign({},baseStyle,{textAlign: "center", paddingRight: 10 , whiteSpace:"nowrap"});
    var costStyle=Object.assign({},baseStyle,{textAlign: "right", paddingLeft: 10, whiteSpace:"nowrap"});
    var titleStyle=Object.assign({},baseStyle,{textAlign: "left", paddingLeft: 5});
    if (this.props.active) {
      timeStyle.backgroundColor="lightgrey";
      costStyle.backgroundColor="lightgrey";
      titleStyle.backgroundColor="lightgrey";
    } else if (this.props.historic) {
      timeStyle.color="grey";
      costStyle.color="grey";
      titleStyle.color="grey"
    } else if (this.props.requestedTransitionTo) {
      timeStyle.fontWeight="bold";
      costStyle.fontWeight="bold";
      titleStyle.fontWeight="bold";
    }
    return (
      <tbody>
        <tr style={{borderSpacing: 10}}>
          <th style={titleStyle}>
            {this.props.name}
            {this.props.requestedException
              ? (
                <span style={{float: "right", paddingRight: 15}}>
                  <Flag requestedStageException={this.props.requestedException} requestedStageTransition={this.props.requestedTransitionTo}/>
                </span>
              ) : null}
          </th>
          <td style={titleStyle}></td>
          <td style={Object.assign({},timeStyle,{minWidth:75*this.props.size!==undefined ? this.props.size : 1})}>{this.props.time.start}</td>
          <td style={Object.assign({},timeStyle,{minWidth:75*this.props.size!==undefined ? this.props.size : 1})}>{this.props.time.end}</td>
          <td style={timeStyle}>{this.props.time.tolerance}</td>
          <td style={costStyle}></td>
          <td style={costStyle}>{this.asNumber(this.props.cost.hours)}</td>
          <td style={costStyle}>{this.asNumber(this.props.cost.expences)}</td>
          <td style={costStyle}>{this.asNumber(this.props.cost.investments)}</td>
          <td style={costStyle}>{this.asNumber(this.props.cost.sum)}</td>
          <td style={costStyle}>{this.asNumber(this.props.cost.tolerance)}</td>
          <td>
            {this.props.showInReport!==true && this.props.historic===undefined ?
              <a onClick={this.editStage.bind(this)} href={"?edit="+this.props.id}><img src="/icons/pen_grey.jpg"/></a>
              : <span/>
            }
          </td>
        </tr>
        <tr>
          <td colSpan="11" style={{borderTop: "solid lightgrey 1px", paddingBottom: 10}}></td>
          <td></td>
        </tr>
      </tbody>
    );
  }
}

class StageForm extends React.Component {
  render() {
    var updateActionLabel=(this.props.requestedException) ? "Approve" : (this.props.active) ? "Request" : (this.props.requestedTransitionTo) ? "Update request" : "Save";
    return (
      <tbody>
          <tr>
            <td style={{textAlign: "left"}}>
              <input type="hidden" name="id" value={this.props.id}/>
              <input className="input" placeholder="Name" name="name" defaultValue={this.props.name}/>
              {this.props.requestedException
                ? (
                  <span style={{float: "right", paddingRight: 15}}>
                    <Flag requestedStageException={this.props.requestedException} requestedStageTransition={this.props.requestedTransitionTo}/>
                  </span>
                ) : null}
            </td>
            <td></td>
            <td style={{textAlign:"center"}}>
              <input size="12" name="time_start" placeholder="start date"
                defaultValue={this.props.time!==undefined ? this.props.time.start : ""}/>
            </td>
            <td style={{textAlign:"center"}}>
              <input size="12" name="time_end" placeholder="end date"
                defaultValue={this.props.time!==undefined ? this.props.time.end : ""}/>
            </td>
            <td style={{textAlign:"center"}}>
              <input size="12" name="time_tolerance" placeholder="tolerance"
                defaultValue={this.props.time!==undefined ? this.props.time.tolerance : ""}/>
            </td>
            <td></td>
            <td style={{textAlign:"right"}}>
              <input size="12" name="cost_hours" placeholder="hours" style={{textAlign: "right"}}
                defaultValue={this.props.cost!==undefined ? this.props.cost.hours : ""}/>
            </td>
            <td style={{textAlign:"right"}}>
              <input size="12" name="cost_expences" placeholder="expences" style={{textAlign: "right"}}
                defaultValue={this.props.cost!==undefined ? this.props.cost.expences : ""}/>
            </td>
            <td style={{textAlign:"right"}}>
              <input size="12" name="cost_investment" placeholder="investment" style={{textAlign: "right"}}
                defaultValue={this.props.cost!==undefined ? this.props.cost.investment : ""}/>
            </td>
            <td style={{textAlign:"right"}}>
              <input size="12" name="cost_sum" placeholder="sum" style={{textAlign: "right"}}
                defaultValue={this.props.cost!==undefined ? this.props.cost.sum : ""}/>
            </td>
            <td style={{textAlign:"right"}}>
              <input size="12" name="cost_tolerance" placeholder="tolerance" style={{textAlign: "right"}}
                defaultValue={this.props.cost!==undefined ? this.props.cost.tolerance : ""}/>
            </td>
          </tr>
          <tr>
            <td colSpan="2"></td>
            <td colSpan="3" style={{color:"grey", verticalAlign:"top", paddingTop:20}}>
              Note:
              <ul style={{marginTop:0}}>
                <li>Dates should follow yyyy-mm-dd format for<br/> correct sorting</li>
                <li style={{marginTop:"1em"}}>Tolerance units are igored. Tolerance numbers<br/> are summarized without unit conversion.</li>
              </ul>
            </td>
            <td></td>
            <td colSpan="5" style={{paddingTop: 20, paddingBottom:15}}>
              <div>
                <textarea style={{float:"right"}} cols="70" rows="8" name="comments" placeholder="Comments" defaultValue={this.props.comments}/>
              </div>
              <div style={{paddingTop:15, float:"right"}}>
                {this.props.requestedTransitionTo && updateActionLabel==="Update request" ? <p>Requested transition to, update request.</p> : <span/>}
                <input onClick={this.props.onCancel} className="cancel" type="submit" name="cancel" value="Cancel"/>
                <span style={{paddingRight:30}}> </span>
                <input style={{marginRight:0}} className="save" type="submit" name="action" value={updateActionLabel}/>
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan="11" style={{borderTop: "solid lightgrey 1px", paddingBottom: 10}}></td>
          </tr>
      </tbody>
    );
  }
}

class ProjectTotal extends React.Component {
  intValue(value) {
    var intValue=parseFloat(value);
    return isNaN(intValue) ? 0 : intValue;
  }

  render() {
    var baseStyle={backgroundColor: "#EEEEEE", borderTop:"double black 3px", borderBottom:" solid black 1px", paddingTop: 5, paddingBottom: 5, fontWeight: "bold"};
    var timeStyle=Object.assign({},baseStyle,{textAlign: "center", paddingRight: 10 , whiteSpace:"nowrap"});
    var costStyle=Object.assign({},baseStyle,{textAlign: "right", paddingLeft: 10, whiteSpace:"nowrap"});
    var titleStyle=Object.assign({},baseStyle,{textAlign: "left", paddingLeft: 5});
    var minDate=(this.props.project.stages!==undefined) ? this.props.project.stages.map(stage=>stage.time.start).sort()[0] : "";
    var maxDate=(this.props.project.stages!==undefined) ? this.props.project.stages.map(stage=>stage.time.end).sort().reverse()[0] : "";
    var sumTimeTolerance=(this.props.project.stages!==undefined) ? this.props.project.stages.reduce((a,b) => a + this.intValue(b.time.tolerance),0) : "";
    var sumHours=(this.props.project.stages!==undefined) ? this.props.project.stages.reduce((a,b) => a + this.intValue(b.cost.hours),0) : 0;
    var sumExpences=(this.props.project.stages!==undefined) ? this.props.project.stages.reduce((a,b) => a + this.intValue(b.cost.expences),0) : 0;
    var sumInvestment=(this.props.project.stages!==undefined) ? this.props.project.stages.reduce((a,b) => a + this.intValue(b.cost.investment),0): 0;
    var sumCost=(this.props.project.stages!==undefined) ? this.props.project.stages.reduce((a,b) => a + this.intValue(b.cost.sum),0) : 0;
    var sumCostTolerance=(this.props.project.stages!==undefined) ? this.props.project.stages.reduce((a,b) => a + this.intValue(b.cost.tolerance),0) : 0;
    return (
      <tbody>
        <tr style={{borderSpacing: 10}}>
          <th colSpan="2" style={titleStyle}>Complete project</th>
          <td style={timeStyle}>{minDate}</td>
          <td style={timeStyle}>{maxDate}</td>
          <td style={timeStyle}>{sumTimeTolerance}</td>
          <td style={costStyle}></td>
          <td style={costStyle}>{sumHours.toLocaleString()}</td>
          <td style={costStyle}>{sumExpences.toLocaleString()}</td>
          <td style={costStyle}>{sumInvestment.toLocaleString()}</td>
          <td style={costStyle}>{sumCost.toLocaleString()}</td>
          <td style={costStyle}>{sumCostTolerance.toLocaleString()}</td>
          <td style={timeStyle}></td>
        </tr>
      </tbody>
    );
  }
}

function convertScheduleToPlan1Stages(schedule) {
  return schedule.map(phase=>Object.assign({},phase,{
    items: phase.items.map(stage=>Object.assign({},stage, {
      time: {
        start: stage.start,
        end: stage.end,
        tolerance: stage.timeTolerance
      },
      cost: {
        hours: stage.hours,
        expences: stage.expences,
        investments: stage.investments,
        sum: stage.sum,
        tolerance: stage.costTolerance
      }
    }))
  }));
}

export class ProjectPlan extends React.Component {
  constructor(props) {
    super(props);
    this.state={stages:this.props.project.stages};
  }

  addRow(event) {
    event.preventDefault();
    if (this.props.onAddStage!==undefined) {
      this.props.onAddStage();
    }
    this.setState({addRowEnabled:true, editStage:undefined});
  }

  cancelEdit(event) {
    event.preventDefault();
    this.setState({addRowEnabled:false,editStage:undefined});
  }

  editStage(stageId) {
    if (this.props.onEditStage!==undefined) {
      this.props.onEditStage(stageId);
    } else {
      this.setState({addRowEnabled:false, editStage:stageId});
    }
  }

  submitForm(event) {
    if (this.props.onSubmit!==undefined) {
      this.props.onSubmit(event)
        .then((stages)=>{
          this.setState({stages:stages, addRowEnabled:false, editStage:undefined});
        })
        .catch(error=>{
          alert("Could not update plan, please try again. \nDetails: "+JSON.stringify(error));
        })
    }
  }

  render() {
    let labels=translations.getTranslation(this.props).schedule.fields.schedule;
    let currency=this.props.project.currency;
    return (
      <div style={{marginLeft: 20}}>
        {this.props.showInReport!==true ? (
          <h2>Project plan</h2>
          ) : null
        }
        <form method="POST" action="./plan" onSubmit={this.submitForm.bind(this)}>
        <table style={{fontSize: this.props.fontSize===undefined ? "inherit" : this.props.fontSize }} cellPadding="0" cellSpacing="0">
          <thead>
            <tr>
              <th style={{width: 300, backgroundColor:"#EEEEEE"}}></th>
              <th style={{width:50}}></th>
              <th colSpan="3" style={{fontWeight:"normal",fontFamily:"Arial, Helvetica Neue, Helvetica, sans-serif", background:"#EEEEEE", textAlign:"center", color:"grey",fontSize:"140%"}}>{labels.columnHeaders.time.title}</th>
              <th style={{width: 50}}></th>
              <th colSpan="5"style= {{fontWeight:"normal", fontFamily:"Arial, Helvetica Neue, Helvetica, sans-serif", background:"#EEEEEE", textAlign:"center", color:"grey", fontSize:"140%"}}>
                {labels.columnHeaders.cost.title}
                {currency!==undefined ? (
                  <span> ({currency})</span>
                ) : null}
              </th>
              <th/>
            </tr>
            <tr>
              <th colSpan="2"></th>
              <th style={{paddingTop:10,borderBottom:"solid grey 1px",paddingRight: 10}}>{labels.columns.start.title}</th>
              <th style={{paddingTop:10,borderBottom:"solid grey 1px",paddingRight: 10}}>{labels.columns.end.title}</th>
              <th style={{paddingTop:10,borderBottom:"solid grey 1px"}}>{labels.columns.timeTolerance.title}{this.props.showInReport===true && labels.columns.timeTolerance.note!==undefined ? " *":null}</th>
              <th></th>
              <th style={{paddingTop:10,borderBottom:"solid grey 1px",paddingRight: 10}}>{labels.columns.hours.title}</th>
              <th style={{paddingTop:10,borderBottom:"solid grey 1px",paddingRight: 10}}>{labels.columns.expences.title}</th>
              <th style={{paddingTop:10,borderBottom:"solid grey 1px",paddingRight: 10}}>{labels.columns.investments.title}</th>
              <th style={{paddingTop:10,borderBottom:"solid grey 1px",paddingRight: 10}}>{labels.columns.sum.title}</th>
              <th style={{paddingTop:10,borderBottom:"solid grey 1px"}}>{labels.columns.costTolerance.title}</th>
              <th/>
            </tr>
            <tr>
              <td colSpan="12" style={{paddingTop: 10}}></td>
            </tr>
          </thead>
          {this.state.stages!==undefined && this.props.planVersion!=="2"
            ? this.state.stages.map(stage => {
              return (stage.id===this.props.edit || stage.id===this.state.editStage)
                ? <StageForm key={stage.id} {...stage} onCancel={this.cancelEdit.bind(this)}/>
              : <Stage key={stage.id} {...stage} onEdit={this.editStage.bind(this)} showInReport={this.props.showInReport}/>;
              })
            : (
              <tbody>
                <tr>
                  <td colSpan="12" style={{paddingLeft: 15}}></td>
                </tr>
              </tbody>
            )

          }
          {this.props.add && this.props.planVersion!=="2" || this.state.addRowEnabled ? <StageForm onCancel={this.cancelEdit.bind(this)}/> : null}
          {this.props.planVersion!=="2"? (
            <ProjectTotal {...this.props}/>
          ) : null}
          {this.props.planVersion!=="2" && this.props.showInReport!==true && this.props.project.state!=="completed" && (this.props.project.requestedStageTransition===undefined || (this.props.project.requestedStageTransition!==undefined && this.props.project.requestedStageTransition.stage))!==undefined ? (
            <tbody>
              <tr>
                <td colSpan="12" style={{paddingTop: 20}}><a onClick={this.addRow.bind(this)} href="?add=true">Add row</a></td>
              </tr>
            </tbody>
          ) : null}
          {this.props.planVersion==="2" ? (
            convertScheduleToPlan1Stages(addTotalsToSchedule(setupSchedule(this.state.stages,this.props), this.props))
              .map(phase=>[
                <tbody>
                  <tr>
                    <td colSpan="12" style={{paddingTop:20, paddingBottom:5, fontWeight:"bold", fontSize:"120%"}}>{phase.text}</td>
                  </tr>
                </tbody>
              ].concat(phase.items
                .filter(stage=>stage!==undefined)
                .map(stage=>(
                <Stage key={stage.id} {...stage} showInReport={this.props.showInReport}/>
                ))
              )
            )
          ) : null}

        </table>
        {this.props.showInReport===true && labels.columns.timeTolerance.note!==undefined ? (
          <div style={{fontSize: this.props.fontSize===undefined ? "inherit" : this.props.fontSize }}>
            * {labels.columns.timeTolerance.note}
          </div>
        ) : null}
        </form>
      </div>
    );
  }
}

export default class ProjectPlanPage extends React.Component {
  render() {
    var menu=(this.props.showMenu===true) ? <ProjectMenu {...this.props}/> : undefined;
    return (
      <Layout {...this.props} projectMenu={menu}>
        <ProjectPlan {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/ProjectPlan.jsx